// extracted by mini-css-extract-plugin
module.exports = {"content":"DeleteStep_content__1x9NN"};